import { datadogRum } from '@datadog/browser-rum';
import { Amplify } from 'aws-amplify';
import { AppLayout, RumContext } from 'components/shell';
import { GraphqlWrapper } from 'components/shell/graphql-wrapper';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { DemoNamesProvider } from 'providers/demo-mode';
import { OutreachActivityProvider } from 'providers/outreach-activity';
import { SnackbarProvider } from 'providers/snackbar';
import { FC } from 'react';
import { BrowserRouter } from 'react-router';
import { Router } from 'router';
import { initRum } from 'utils/datadog-rum';
import AuthWrapper from './components/shell/auth-wrapper';
import amplifyConfigs from './configs/amplify-config';

const VITE_LAUNCH_DARKLY_KEY = import.meta.env.VITE_LAUNCH_DARKLY_KEY;

const config = amplifyConfigs();
if (config.Auth?.Cognito.userPoolId && config.Auth?.Cognito.userPoolClientId) {
  Amplify.configure(config);
}

initRum();
datadogRum.startSessionReplayRecording();

export const App: FC = () => {
  return (
    <BrowserRouter>
      <AuthWrapper>
        <RumContext />
        <DemoNamesProvider>
          <SnackbarProvider>
            <GraphqlWrapper>
              <OutreachActivityProvider>
                <AppLayout>
                  <Router />
                </AppLayout>
              </OutreachActivityProvider>
            </GraphqlWrapper>
          </SnackbarProvider>
        </DemoNamesProvider>
      </AuthWrapper>
    </BrowserRouter>
  );
};

let WrappedApp = App as any;

if (VITE_LAUNCH_DARKLY_KEY) {
  WrappedApp = withLDProvider({
    clientSideID: VITE_LAUNCH_DARKLY_KEY as string,
  })(App);
}

export default WrappedApp;
